export default "__VITE_ASSET__CD8rbAmG__"